<template>
  <message
    :class="['notification', `notification--${type}`]"
    :modifiers="baseModifiers"
    :cookie="cookie"
    :can-close="canClose"
    :show="show"
    @close="$emit('close')"
  >
    <sprite class="notification__sprite" :id="`app/${spriteId}`" />
    <slot />
  </message>
</template>

<script>
import Message from "@/shared/message"
import Sprite from "@/shared/sprite"
import "/wds/sprites/app/error.svg"
import "/wds/sprites/app/information.svg"

export default {
  name: "Notification",
  components: {
    Message,
    Sprite
  },
  props: {
    type: {
      type: String,
      default: "notification",
      validator(value) {
        return ["notification", "error", "success", "warning"].includes(value)
      }
    },
    cookie: { type: String, default: null },
    show: { type: Boolean, default: true },
    canClose: { type: Boolean, default: false }
  },
  computed: {
    baseModifiers() {
      const modifiers = []
      switch (this.type) {
        case "error":
          modifiers.push("background-red")
          break
        case "notification":
          modifiers.push("background-blue")
          break
        case "success":
          modifiers.push("background-green")
          break
        case "warning":
          modifiers.push("background-blue")
          break
      }
      return modifiers
    },
    spriteId() {
      if (this.type === "notification") {
        return "information"
      }
      if (this.type === "success") {
        return "added"
      }
      if (this.type === "warning") {
        return "error"
      }
      return this.type
    }
  }
}
</script>

<style lang="scss">
.notification {
  @include font-style(error, $color: null, $line-height: 20px);

  display: flex;
  align-items: center;

  &__sprite {
    flex-shrink: 0;
    margin-right: $spacing-16;
  }

  &--error {
    color: $raspberry;
  }

  &--notification {
    color: $blue2;
  }

  &--success {
    color: $accessible-green;
  }

  &--warning {
    color: $black;
  }

  a {
    text-decoration: underline;
  }
}
</style>
